import { getNumberFromString } from '@/utils/formatUtils'
import { PHONE_NUMBER_FIELD_PREFIX } from './constants'
import type { TTextInputTransformer } from './types'

export const normalizePhoneNumber: TTextInputTransformer = value => {
  const phoneNumberNormalized = String(value).replace(/\D/g, '')

  return phoneNumberNormalized.length === 10 && !phoneNumberNormalized.startsWith(PHONE_NUMBER_FIELD_PREFIX)
    ? `${PHONE_NUMBER_FIELD_PREFIX}${phoneNumberNormalized}`
    : phoneNumberNormalized
}

export const normalizeNumber: TTextInputTransformer = value => value.replace(',', '.')

export const normalizePrice: TTextInputTransformer = value => {
  const normalizedPriceString = normalizeNumber(value)
  const price = getNumberFromString(normalizedPriceString)

  if (Number.isNaN(price)) {
    return ''
  }

  return String(price)
}
